<!-- @format -->

@if (!showSuccessMsg) {
  <div
    class="form-container">
    <div class="text-container">
      <p class="hmf-mb-l hmf-pt-l hmf-header-m">
        Please enter your email so we can notify you when the item is in stock
      </p>
      <p class="hmf-mb-xxs hmf-subheader-bold-m gray900">
        {{ productTitle }}
      </p>
      <p class="product-attributes hmf-subheader-m hmf-mb-0">
        {{ attributeDisplay }}
      </p>
    </div>
    <form
      [formGroup]="notifyUserForm"
      class="form hmf-mt-l"
      (ngSubmit)="notifyUser(shipMode)">
      <hmf-text-input
        type="email"
        label="Enter Your Email Address"
        formControlName="email"
        id="prod-av-notif-email"
        [error]="!!emailValidationState"
			[helperText]="
				emailValidationState
					? emailValidationState === 'missing'
						? 'Email is required'
						: 'Email must be a valid email address'
					: undefined
			"></hmf-text-input>
      @if (showErrorMsg) {
        <div class="alert-banner-wrapper hmf-my-m">
          <hmf-alert-banner
            type="alert"
            title="Sorry! Request Failed. Please Try Again Later."
            message="Your request failed because of an unexpected system error."></hmf-alert-banner>
        </div>
      }
    </form>
    @if (notifyMeGoldMessageEnabled()) {
      <pdp-product-availability-notification-gold-message
        class="hmf-ml-l"
        [isPanelText]="true"
        [showDetailsLink]="true">
      </pdp-product-availability-notification-gold-message>
    }
    <div class="button-container">
      <button
        hmf-button
        class="hmf-mt-l hmf-mb-0"
        variant="primary"
        id="notify-btn"
        aria-label="Notify Me"
        [disabled]="notifyUserForm?.invalid"
        (click)="notifyUser(shipMode)"
        text="Notify Me">
        Notify Me
      </button>
      <button
        hmf-button
        class="hmf-mt-s"
        variant="tertiary"
        aria-label="Cancel"
        id="cancel-btn"
        (click)="closePanel()"
      [text]="cancelButtonText"></button>
    </div>
  </div>
}
<!-- end form-container -->

@if (showSuccessMsg) {
  <div
    id="backinstock_rr"
    class="hmf-pt-l">
    <div class="hmf-display-flex hmf-mb-s">
      <homefield-icon
        width="16px"
        height="16px"
        name="sign-circled-check"
        class="sign-circled-check hmf-mr-xxs"
        fill="var(--hmf-fill-positive)">
      </homefield-icon>
      <div class="hmf-header-xs">
        We Are On It! We’ll let you know when the item is available.
      </div>
    </div>
    <shared-components-product-recommendations
      [displayName]="'Similar Products to Consider'"
      [filterBy]="'backinstock_rr'"
      [showViewMoreLink]="false"
      [imageSize]="'small'"
      [numberOfSkeletonCards]="6"
      [isSidePanelRecs]="true"
      [isSidePanelRecsRedesign]="isNewRecsCardsNotifyMePanelEnabled()"
      [showSkeletonLoading]="isNewRecsCardsNotifyMePanelEnabled() && isLoadingStateRecsEnabled()">
    </shared-components-product-recommendations>
  </div>
}
